// extracted by mini-css-extract-plugin
export default {"container":"hq-z","heading":"iq-z","text":"jq-z","info":"kq-z","link":"lq-z","fullMaxWidth":"mq-z"};